export type EmphasisSegment = {
  text: string;
  emphasized: boolean;
};

/** Splits text on `<em>` / `</em>` markers into plain and emphasized segments. */
export function splitEmphasisSegments(text: string): EmphasisSegment[] {
  return text
    .split(/<em>|<\/em>/)
    .map((part, index) => ({
      text: part,
      emphasized: index % 2 === 1,
    }))
    .filter((segment) => segment.text.length > 0);
}
